<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem; margin-bottom: 0!important;">
		<div class="py-2 border-bottom d-flex align-items-center">
			<el-button type="primary" size="mini" icon="el-icon-search">查询</el-button>
			<el-button type="primary" size="mini" @click="openModel('kpxx')" icon="el-icon-plus">添加</el-button>
		</div>
		<div>
			<el-table :data="kpxxList" style="width: 100%" size="mini"	row-key="id" :tree-props="{ children: 'child', hasChildren: 'hasChildren' }"  @current-change="handleCurrentChange">
				<el-table-column width="80" align="center">
					<template slot="header" slot-scope="scope">编号</template>
					<template slot-scope="scope">{{scope.row.id}}</template>
				</el-table-column>
				<el-table-column width="180">
					<template slot="header" slot-scope="scope">公司全称</template>
					<template slot-scope="scope">{{scope.row.mc}}</template>
				</el-table-column>
				<el-table-column width="120">
					<template slot="header" slot-scope="scope">纳税号</template>
					<template slot-scope="scope">{{scope.row.nsh}}</template>
				</el-table-column>
				<el-table-column width="120">
					<template slot="header" slot-scope="scope">开户行</template>
					<template slot-scope="scope">{{scope.row.khh}}</template>
				</el-table-column>
				<el-table-column width="120">
					<template slot="header" slot-scope="scope">开户账号</template>
					<template slot-scope="scope">{{scope.row.khzh}}</template>
				</el-table-column>
				<el-table-column width="140">
					<template slot="header" slot-scope="scope">公司地址</template>
					<template slot-scope="scope">{{scope.row.gsdz}}</template>
				</el-table-column>
				<el-table-column width="100">
					<template slot="header" slot-scope="scope">座机</template>
					<template slot-scope="scope">{{scope.row.zj}}</template>
				</el-table-column>
				<el-table-column width="80" align="center">
					<template slot="header" slot-scope="scope">姓名</template>
					<template slot-scope="scope">{{scope.row.xm}}</template>
				</el-table-column>
				<el-table-column width="120">
					<template slot="header" slot-scope="scope">手机号</template>
					<template slot-scope="scope">{{scope.row.sjh}}</template>
				</el-table-column>
				<el-table-column width="120">
					<template slot="header" slot-scope="scope">邮寄地址</template>
					<template slot-scope="scope">{{scope.row.yjdz}}</template>
				</el-table-column>
				<el-table-column width="200">
					<template slot="header" slot-scope="scope">客户名称</template>
					<template slot-scope="scope">
						<el-button type="success" size="mini" plain>{{scope.row.khid.mc}}</el-button>
					</template>
				</el-table-column>
				<el-table-column align="center" fixed="right" width="200">
					<template slot="header" slot-scope="scope">操作</template>
					<template slot-scope="scope">
						<!-- <el-button type="primary" size="mini" @click="openModel('kpxx',scope.row)">查看</el-button> -->
						<el-button type="primary" size="mini" @click="openModel('kpxx',scope.row)">编辑</el-button>
						<el-button type="danger" size="mini" @click="deleteItem(scope.row)">删除</el-button>
					</template>
				</el-table-column>
				
			</el-table>
		</div>
		<el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;left: 250px;right: 0;z-index: 100;">
			<div style="flex: 1;" class="px-2">
				<el-pagination :current-page="page.current" :page-sizes="page.sizes" :page-size="page.size"
					layout="total, sizes, prev, pager, next, jumper" 	:total="page.total" @size-change="handleSizeChange"
					@current-change="handleCurrentChange"></el-pagination>
			</div>
		</el-footer>
		<el-dialog title="编辑信息" :visible.sync="createModel" top="10vh">
			<!-- 表单内容 -->
			<div class="d-flex mt-2" >
				<div style="width: 33%">
					<el-form v-if="preUrl ==='kpxx' " ref="form" :model="form.kpxx" label-width="80px">
						<el-form-item label="* 公司全称">
							<el-input v-model="form.kpxx.mc" size="mini" style="width: 95%;"></el-input>
						</el-form-item>
						<el-form-item label="开户账号">
							<el-input v-model="form.kpxx.khzh" size="mini" style="width: 95%;"></el-input>
						</el-form-item>
						<el-form-item label="姓名">
							<el-input v-model="form.kpxx.xm" size="mini" style="width: 95%;"></el-input>
						</el-form-item>
						<el-form-item label="客户名称">
							<el-select v-model="form.kpxx.khid" placeholder="请选择" size="mini">
							    <el-option
							      v-for="item in khlist"
							      :key="item.id"
							      :label="item.mc"
							      :value="item.id">
							    </el-option>
							  </el-select>
						</el-form-item>
					</el-form>
				</div>
				<div style="width: 33%">
					<el-form v-if="preUrl ==='kpxx' " ref="form" :model="form.kpxx" label-width="80px">
						<el-form-item label="纳税号">
							<el-input v-model="form.kpxx.nsh" size="mini" style="width: 95%;"></el-input>
						</el-form-item>
						<el-form-item label="公司地址">
							<el-input v-model="form.kpxx.gsdz" size="mini" style="width: 95%;"></el-input>
						</el-form-item>
						<el-form-item label="手机号">
							<el-input v-model="form.kpxx.sjh" size="mini" style="width: 95%;"></el-input>
						</el-form-item>
					</el-form>
				</div>
				<div style="width: 33%">
					<el-form v-if="preUrl ==='kpxx' " ref="form" :model="form.kpxx" label-width="80px">
						<el-form-item label="开户行">
							<el-input v-model="form.kpxx.khh" size="mini" style="width: 95%;"></el-input>
						</el-form-item>
						<el-form-item label="座机">
							<el-input v-model="form.kpxx.zj" size="mini" style="width: 95%;"></el-input>
						</el-form-item>
						<el-form-item label="邮寄地址">
							<el-input v-model="form.kpxx.yjdz" size="mini" style="width: 95%;"></el-input>
						</el-form-item>
					</el-form>
				</div>
			</div>
		
			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">取 消</el-button>
				<el-button type="primary" @click="submit">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import common from '@/common/mixins/common.js'; // 引入 全局共公样式
import { mapState } from 'vuex'; // 引入 全局 公共数据
export default {
	mixins: [common], // 引入mixins里的common.js
	inject: ['layout'], // 依赖注入
	data() {
		return {
			form: {
				kpxx: {
				},
			},
			createModel: false,
			value:'',
			khlist:[],
			dialogType: "kpxx",
			preUrl: "kpxx", //api
			dialogId: 0,
			kpxxList:[]
		};
		
	},
	computed: {
		...mapState({
			user: state => state.user.user
		})
	},
	created() {
		this.axios.get('/admin/khxxs', { token: true }).then(res => {
			this.khlist = res.data.data;
		});
	},
	methods: {
		getListUrl() {
			return `/admin/${this.preUrl}/${this.page.current}?limit=${this.page.size}`
		},
		// 处理列表结果
		getListResult(e) {
			this.kpxxList = e.list
		},
		openModel(type, item = false) {
			// 初始化表单
			switch (type) {
				// 初始化添加管理员
				case 'kpxx':
					if (!item) {
						this.form.kpxx = {
							id:'',
							mc: '',
							nsh:'',
							khh:'',
							khzh:'',
							gsdz:'',
							zj:'',
							xm:'',
							sjh:'',
							yjdz:'',
							khid:''
						}
						this.dialogId = 0
					} else {
						this.form.kpxx = {
							mc: item.mc,
							id:item.id,
							nsh:item.nsh,
							khh:item.khh,
							khzh:item.khzh,
							gsdz:item.gsdz,
							zj:item.zj,
							xm:item.xm,
							sjh:item.sjh,
							yjdz:item.yjdz,
							khid:item.khid
						}
						this.dialogId = item.id
					}
					break;
			}
			// 打开dialog
			this.createModel = true;
		},
		submit() {
			let f = this.form.kpxx
			let e = {
				mc: f.mc,
				nsh:f.nsh,
				khh:f.khh,
				khzh:f.khzh,
				gsdz:f.gsdz,
				zj:f.zj,
				xm:f.xm,
				sjh:f.sjh,
				yjdz:f.yjdz,
				khid:f.khid,
				cjr:this.user.id
			}
			this.addOrEdit(e, this.dialogId);
			this.createModel = false;
		},
		handleCurrentChange(val) {
			this.currentRow = val;
		}
	}
};
</script>

<style></style>
